import { render } from "./AdBox.vue?vue&type=template&id=76a0be86&scoped=true"
import script from "./AdBox.vue?vue&type=script&lang=js"
export * from "./AdBox.vue?vue&type=script&lang=js"

import "./AdBox.vue?vue&type=style&index=0&id=76a0be86&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\User\\OneDrive - Universidad Nacional de Colombia\\Documentos\\Desarrollo\\Tempo\\Front\\Tempo-Front\\tempo-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76a0be86"]])

export default __exports__